import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from 'app/core/shared/helper/form.helper';
import module from "app/modules/well-header-information/well-header-information.module";

@Component({
  selector: 'app-add-wellbore-modal',
  templateUrl: './add-wellbore-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./add-wellbore-modal.component.scss']
})
export class AddWellboreModalComponent {
  public wellboreForm: FormGroup
  public isSuccess: boolean = false
  public isLoading: boolean = false

  constructor(
    public dialogRef: MatDialogRef<AddWellboreModalComponent>,
    private wellHeaderInfoService : WellHeaderInfoService,
    @Inject(MAT_DIALOG_DATA) public wellsId: any,
    private fb: FormBuilder,
    public dialog: MatDialog,
  ) {}

  ngOnInit(){
    this.wellboreForm = this.initializeForm()

    this.wellboreForm.get('wellboreShortName')?.valueChanges.subscribe(value => {
      if (value && value !== value.toUpperCase()) {
        this.wellboreForm.get('wellboreShortName')?.setValue(value.toUpperCase(), { emitEvent: false });
      }
    });
  }

  initializeForm(){
    return this.fb.group({
      wellId: this.wellsId,
      wellboreShortName: ['', [Validators.required, noWhitespaceValidator()]],
      wellboreLongName: ['', [Validators.required, noWhitespaceValidator()]],
      wellboreStatus: '',
      wellboreNumber: '',
      rigName: '',
      uwbi: '',
      spudDate: new Date,
      thfRkbElevation: 0,
      completionDate: new Date,
      waterDepth: 0,
      tvddf: 0,
      tvdss: 0,
      trajectoryShape: '',
      remarks: '',
    })
  }

  createWellbore(){
    this.wellHeaderInfoService.createWellbore(this.wellboreForm.value).subscribe((res)=>{
      if(res.isSuccess){
        this.isSuccess = true
        this.closeDialog()
      }
    })
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }

  get wellboreLongName() {
    return this.wellboreForm.get('wellboreLongName');
  }

  get wellboreShortName() {
    return this.wellboreForm.get('wellboreShortName');
  }
}
